import { Form, FormInstance } from 'antd';
import React, { useContext, useEffect, useMemo } from 'react';
import { DynamicObjectType } from 'types/commons';

type IRestInputContext = {
  form: FormInstance;
  record?: DynamicObjectType;
  isEdit?: boolean;
};

export const RestInputContext = React.createContext<IRestInputContext>({
  form: null,
});

export const useRestContext = () => {
  const { form, record, isEdit } = useContext(RestInputContext);

  return {
    form,
    record,
    isEdit,
  };
};

export default function RestInputContextUI({
  children,
  onSubmit,
  record,
  handleDataConvert,
  handleSubmitFailed,
  isEdit,
}) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    onSubmit(values);
  };

  const onFinishFailed = (values) => {
    handleSubmitFailed?.(values);
  };
  const values = useMemo(() => ({ form, record, isEdit }), [form, record]);

  useEffect(() => {
    if (handleDataConvert) {
      if (isEdit) {
        if (record?.id) {
          const dataConvert = handleDataConvert(record);
          form.setFieldsValue(dataConvert);
        }
      } else {
        const dataConvert = handleDataConvert(record);
          form.setFieldsValue(dataConvert);
      }
    } else {
      form.setFieldsValue(record);
    }
  }, [record?.id]);

  return (
    <RestInputContext.Provider value={values}>
      <Form
        layout="vertical"
        form={form}
        onFinishFailed={onFinishFailed}
        onFinish={onFinish}
      >
        {children}
      </Form>
    </RestInputContext.Provider>
  );
}
